import React from 'react'

const GlavstrojGrayLogo: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="140"
    height="16"
    viewBox="0 0 140 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_30479_11467)">
      <path d="M136.342 0H131.842V1.66244H136.342V0Z" fill="#8F98A1" />
      <path
        d="M9.30282 15.9581H0.00704483V12.6008L9.30282 6.59101V15.9581Z"
        fill="#8F98A1"
      />
      <path
        d="M10.5634 2.93442L17.0423 7.12694V0.224826H0V9.75848L10.5634 2.93442Z"
        fill="#8F98A1"
      />
      <path
        d="M11.8225 6.59101V15.9568H17.0465V9.97312L11.8225 6.59101Z"
        fill="#8F98A1"
      />
      <path
        d="M29.7563 14.1205V5.47915H36.162V3.22222H27.0591V14.1205H29.7563Z"
        fill="#8F98A1"
      />
      <path
        d="M37.2987 13.7771C37.9733 12.657 38.3114 10.9152 38.3114 8.53084V3.22222H48.2564V14.1205H45.5564V5.47915H41.0071V8.29801C41.0071 11.0843 40.6874 13.0148 40.0466 14.1205H37.2987V13.7771Z"
        fill="#8F98A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.5142 3.22222H54.6438L50.0072 14.1205H52.9565L53.8663 11.8622H59.2945L60.2043 14.1205H63.1621L58.5142 3.22222ZM56.5818 5.15264L58.3846 9.60531H54.7776L56.5818 5.15264Z"
        fill="#8F98A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.9154 3.22222H70.983C73.276 3.22222 74.776 4.32791 74.776 6.02417C74.776 7.20791 74.1366 8.03263 72.838 8.51523C74.3211 8.90547 75.1971 9.79263 75.1971 11.0843C75.1971 13.0148 73.6295 14.1205 71.0675 14.1205H64.9154V3.22222ZM70.8999 7.42515C71.7253 7.42515 72.1675 7.05182 72.1675 6.41442C72.1675 5.85377 71.7126 5.47915 70.8999 5.47915H67.6126V7.43037L70.8999 7.42515ZM71.2366 11.8622C72.0619 11.8622 72.5844 11.4421 72.5844 10.7734C72.5844 10.1048 72.0619 9.68336 71.2366 9.68336H67.6126V11.8622H71.2366Z"
        fill="#8F98A1"
      />
      <path
        d="M86.6506 9.0135C86.2619 10.8346 85.0661 12.0184 83.0605 12.0184C81.1717 12.0184 79.5534 10.7267 79.5534 8.66879C79.5534 6.64472 81.1041 5.3218 82.9929 5.3218C84.6281 5.3218 85.8238 6.20895 86.1619 7.71919L88.6393 6.69415C88.1337 4.65448 86.1619 3.06619 83.0436 3.06619C79.5872 3.00505 76.79 5.54163 76.8562 8.67139C76.8562 11.8779 79.2844 14.2753 83.0436 14.2753C86.2788 14.2753 88.4365 12.6103 89.1281 9.93188L86.6506 9.0135Z"
        fill="#8F98A1"
      />
      <path
        d="M100.686 5.47915H96.6408V14.1205H93.9436V5.47915H89.8985V3.22222H100.686V5.47915Z"
        fill="#8F98A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.569 14.1205H105.266V10.0723H108.215C110.811 10.0723 112.177 8.40597 112.177 6.63167C112.177 4.79492 110.845 3.22222 108.215 3.22222H102.569V14.1205ZM109.48 6.64466C109.48 7.39523 108.924 7.81539 108.048 7.81539H105.266V5.47393H108.048C108.924 5.47393 109.48 5.89409 109.48 6.64466Z"
        fill="#8F98A1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.335 8.67135C126.403 11.7074 123.486 14.3534 120.099 14.2753C116.71 14.3534 113.794 11.7074 113.862 8.67135C113.794 5.63525 116.71 3.00501 120.099 3.06615C123.486 3.00501 126.401 5.63786 126.335 8.67135ZM123.638 8.67135C123.638 6.67851 122.07 5.40241 120.099 5.40241C118.127 5.40241 116.559 6.67851 116.559 8.67135C116.559 10.6642 118.127 11.9403 120.099 11.9403C122.07 11.9403 123.638 10.6642 123.638 8.67135Z"
        fill="#8F98A1"
      />
      <path
        d="M128.345 14.1205H132.964L137.286 4.88467V14.1205H139.983V3.22222H135.365L131.049 12.458V3.22222H128.345V14.1205Z"
        fill="#8F98A1"
      />
    </g>
    <defs>
      <clipPath id="clip0_30479_11467">
        <rect width="140" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default GlavstrojGrayLogo
